import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "app/core/service/auth/auth.service";
import { environment } from "environments/environment";
import { BehaviorSubject } from "rxjs";
import { finalize, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ContentLibraryService {
  private _isLoading$ = new BehaviorSubject<boolean>(false);
  private _isLoadingtable$ = new BehaviorSubject<boolean>(false);
  private _isproccessing$ = new BehaviorSubject<boolean>(false);
  private _isviewload$ = new BehaviorSubject<boolean>(false);
  private _istranscribing$ = new BehaviorSubject<boolean>(false);
  private _isLoadingcomment$ = new BehaviorSubject<boolean>(false);
  private _isLoadingdownload$ = new BehaviorSubject<boolean>(false);
  private _isLoadingAssetLabel$ = new BehaviorSubject<boolean>(false);

  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient, protected authService: AuthService) { }

  get isLoading$() {
    return this._isLoading$.asObservable();
  }

  get isviewload$() {
    return this._isviewload$.asObservable();
  }

  get isLoadingtable$() {
    return this._isLoadingtable$.asObservable();
  }

  get isLoadingcomment$() {
    return this._isLoadingcomment$.asObservable();
  }

  get isLoadingAssetLabel$() {
    return this._isLoadingAssetLabel$.asObservable();
  }

  get isLoadingdownload$() {
    return this._isLoadingdownload$.asObservable();
  }

  get isproccessing$() {
    return this._isproccessing$.asObservable();
  }

  get istranscribing$() {
    return this._istranscribing$.asObservable();
  }

  create(admin: any) {
    this._isLoading$.next(true);
    return this.http.post(`${this.apiUrl}/content/library/add`, admin).pipe(
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  submitImport(param) {
    return this.http.post(
      `${this.apiUrl}/content/library/claim/asset/original/import`,
      param
    );
  }

  exportCSV(params) {
    return this.http.post(`${this.apiUrl}/content/library/latest/csv`, params);
  }

  deletePackage(id) {
    return this.http.delete(`${this.apiUrl}/CID/asset/zip/package/${id}`);
  }

  switchAcccount(param) {
    return this.http
      .post(`${this.apiUrl}/user/content/owner/switch`, param)
      .pipe(
        map((auth: any) => {
          auth.result.profile_picture = `${auth.result.profile_picture}`;
          auth.result.channel_status = `${auth.channel_status}`;
          auth.result.contractCount = `${auth.contractCount}`;
          if (auth.result.type == "8") {
            if (auth.team_member_type == "creator") {
              auth.result.type = 9;
            }
          }
          const result = this.authService.setStorage(auth);

          this.authService.currentUserSubject.next(auth.result);
          return auth;
        })
      );
  }
  getallContentCount(param) {
    this._isLoading$.next(true);
    return this.http
      .post(`${this.apiUrl}/content/library/claim/asset/original/count`, param)
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        })
      );
  }

  getzipPackage() {
    return this.http.get(`${this.apiUrl}/CID/asset/zip/package`);
  }
  getallContent(param) {
    this._isLoading$.next(true);
    return this.http
      .post(`${this.apiUrl}/content/library/claim/asset/original`, param)
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        })
      );
  }
  updatecomment(json) {
    return this.http.post(`${this.apiUrl}/content/library/edit/notes`, json);
  }

  uploadfile(file: any) {
    this._isproccessing$.next(true);
    return this.http.post(`${this.apiUrl}/general/rev/upload/file`, file).pipe(
      finalize(() => {
        this._isproccessing$.next(false);
      })
    );
  }
  deletenote(params) {
    return this.http.post(
      `${this.apiUrl}/content/library/delete/notes`,
      params
    );
  }
  filestatus(jobdata) {
    return this.http.post(
      `${this.apiUrl}/general/rev/upload/file/status`,
      jobdata
    );
  }

  downloadfile(downloadjson) {
    this._isLoadingdownload$.next(true);
    return this.http
      .post(`${this.apiUrl}/content/library/download/clip/path`, downloadjson)
      .pipe(
        finalize(() => {
          this._isLoadingdownload$.next(false);
        })
      );
  }

  AudioDownload(param) {
    this._isLoadingdownload$.next(true);
    return this.http
      .post(`${this.apiUrl}/content/library/download/audio`, param)
      .pipe(
        finalize(() => {
          this._isLoadingdownload$.next(false);
        })
      );
  }

  footageDownload(param) {
    this._isLoadingdownload$.next(true);
    return this.http
      .post(`${this.apiUrl}/content/library/download/footage`, param)
      .pipe(
        finalize(() => {
          this._isLoadingdownload$.next(false);
        })
      );
  }
  likedislikedownload(param) {
    this._isLoadingdownload$.next(true);
    return this.http
      .post(`${this.apiUrl}/content/library/download/like/dislike`, param)
      .pipe(
        finalize(() => {
          this._isLoadingdownload$.next(false);
        })
      );
  }

  createnotes(admin: any) {
    this._isLoadingcomment$.next(true);
    return this.http
      .post(`${this.apiUrl}/content/library/add/notes`, admin)
      .pipe(
        finalize(() => {
          this._isLoadingcomment$.next(false);
        })
      );
  }

  updateAssetTitle(admin: any) {
    this._isLoadingAssetLabel$.next(true);
    return this.http
      .put(`${this.apiUrl}/cid/asset/title`, admin)
      .pipe(
        finalize(() => {
          this._isLoadingAssetLabel$.next(false);
        })
      );
  }

  updateAssetReferenceFile(admin: any) {
    this._isLoadingAssetLabel$.next(true);
    return this.http
      .post(`${this.apiUrl}/content/library/update/reference`, admin)
      .pipe(
        finalize(() => {
          this._isLoadingAssetLabel$.next(false);
        })
      );
  }

  retryAssetReferenceFile(admin: any) {
    this._isLoadingAssetLabel$.next(true);
    return this.http
      .post(`${this.apiUrl}/content/library/retry/reference`, admin)
      .pipe(
        finalize(() => {
          this._isLoadingAssetLabel$.next(false);
        })
      );
  }

  revtext(jobdata) {
    this._istranscribing$.next(true);
    return this.http.post(`${this.apiUrl}/general/rev/text`, jobdata).pipe(
      finalize(() => {
        this._istranscribing$.next(false);
      })
    );
  }

  getall(params) {
    this._isLoadingtable$.next(true);
    return this.http.post(`${this.apiUrl}/content/library`, params).pipe(
      finalize(() => {
        this._isLoadingtable$.next(false);
      })
    );
  }

  getallNewAPI(params) {
    this._isLoadingtable$.next(true);
    return this.http.post(`${this.apiUrl}/content/library/latest`, params).pipe(
      finalize(() => {
        this._isLoadingtable$.next(false);
      })
    );
  }

  getallpendinglibrary(params) {
    this._isLoadingtable$.next(true);
    return this.http
      .post(`${this.apiUrl}/content/library/claim/asset/original`, params)
      .pipe(
        finalize(() => {
          this._isLoadingtable$.next(false);
        })
      );
  }

  GetCountLibraryPending(params) {
    return this.http.post(
      `${this.apiUrl}/content/library/claim/asset/original/count`,
      params
    );
  }

  GetCount(params) {
    return this.http.post(`${this.apiUrl}/content/library/count`, params);
  }

  GetCountNewApi(params) {
    return this.http.post(`${this.apiUrl}/content/library/count/latest`, params);
  }

  delete(id) {
    return this.http.delete(`${this.apiUrl}/content/library/${id}`);
    // return this.http.delete(`${this.apiUrl}/user/${id}`);
  }

  deleteMany(params) {
    return this.http.post(`${this.apiUrl}/content/library/delete`, params);
  }

  changestatus(id, status) {
    return this.http.put(`${this.apiUrl}/user/change-status/${id}`, { status });
  }

  getById(id) {
    this._isviewload$.next(true);
    return this.http
      .patch(`${this.apiUrl}/content/library/detail/${id}`, {})
      .pipe(
        finalize(() => {
          this._isviewload$.next(false);
        })
      );
  }

  update(admin: any, id: any) {
    this._isLoading$.next(true);
    return this.http.put(`${this.apiUrl}/content/library/${id}`, admin).pipe(
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }

  updatecontent(admin: any, id: any) {
    this._isLoading$.next(true);
    return this.http
      .put(`${this.apiUrl}/content/library/content/owner/${id}`, admin)
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        })
      );
  }

  getUnreadNotificationCount() {
    this._isLoadingtable$.next(true);
    return this.http.get(`${this.apiUrl}/notification/count`).pipe(
      finalize(() => {
        this._isLoadingtable$.next(false);
      })
    );
  }

  getTotalNotification() {
    this._isLoadingtable$.next(true);
    return this.http.get(`${this.apiUrl}/notification`).pipe(
      finalize(() => {
        this._isLoadingtable$.next(false);
      })
    );
  }

  notificationMarkAsRead(notificationId: string) {
    this._isLoadingtable$.next(true);
    return this.http.put(`${this.apiUrl}/notification/${notificationId}`, { read: 2 }).pipe(
      finalize(() => {
        this._isLoadingtable$.next(false);
      })
    );
  }

  notificationMarkAsDismissed(notificationId: string) {
    this._isLoadingtable$.next(true);
    return this.http.put(`${this.apiUrl}/notification/${notificationId}`, { dismiss: 2 }).pipe(
      finalize(() => {
        this._isLoadingtable$.next(false);
      })
    );
  }
}
